export const DeclaredTerritoryMapping = {
  '6': 'office_bool',
  '8': 'indigenous_land_bool',
  '13': 'pae_bool',
  '3': 'quilombo_bool'
}
